import React from "react";

/**
 * NestedItemActions - A reusable component for action buttons in nested items
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Action buttons to display
 * @param {string} props.className - Additional CSS classes
 */
const NestedItemActions = ({ children, className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>{children}</div>
  );
};

export default NestedItemActions;
